import { Link, useLocation } from 'react-router-dom';

/** In-page anchor on the home page; routes back to "/" first from any other page. */
export default function AnchorLink({ href, children, ...rest }) {
  const { pathname } = useLocation();
  if (pathname === '/' || !href.startsWith('#')) {
    return <a href={href} {...rest}>{children}</a>;
  }
  return <Link to={`/${href}`} {...rest}>{children}</Link>;
}
